import { render, staticRenderFns } from "./AddressPicker.vue?vue&type=template&id=64452e26&scoped=true&"
import script from "./AddressPicker.vue?vue&type=script&lang=js&"
export * from "./AddressPicker.vue?vue&type=script&lang=js&"
import style0 from "./AddressPicker.vue?vue&type=style&index=0&id=64452e26&prod&lang=scss&scoped=true&"
import style1 from "./AddressPicker.vue?vue&type=style&index=1&id=64452e26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64452e26",
  null
  
)

export default component.exports